import React from 'react';
import { Tabs as MaterialUiTabs, TabsProps } from '@mui/material';
import { ISharedProps } from '../../tools/ISharedProps';

interface ITabsProps extends TabsProps, ISharedProps {
  onChange: any;
}

export const Tabs = ({ onChange, variant = 'scrollable', ...props }: ITabsProps) => (
  <MaterialUiTabs
    indicatorColor="primary"
    textColor="primary"
    {...props}
    onChange={onChange}
    variant={variant}
  />
);
